import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { changelogApi } from 'api';
import { queryKey } from 'api/types';
import { useProfileStorage } from 'hooks/profile';
import { showChangelogDialog } from './ChangelogDialog';

export const useChangelog = () => {
  const { isAnonymous } = useProfileStorage();
  const enabled = !isAnonymous;

  const { data: changelog } = useQuery([queryKey.changelog], changelogApi.changelog, {
    select: response => response.results,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    enabled,
  });

  useEffect(() => {
    if (!changelog?.length) {
      return;
    }
    const dialog = showChangelogDialog(changelog);

    return dialog?.destroy;
  }, [changelog]);
};
